import { useData } from "./DataContext.js";

import { BsFillCheckCircleFill, BsFillXCircleFill } from "react-icons/bs";

import Card from "react-bootstrap/Card";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

export default function ItemCard (props)
{
    const gData = useData();
    
    let itemContent = gData.content.items[props.itemId];
    if (props.itemId === null)
    {
	const titles = { info: "Information inconnue", bp: "Conseil inconnu", indice: "Indice inconnu" };
	itemContent = {
	    type: null,
	    title: titles[props.type],
	    description: ""
	};
    }
    
    let bgColor = "bg-secondary-subtle";
    switch (itemContent.type)
    {
	case "info": bgColor = "bg-warning-subtle border-warning"; break;
	case "bp": bgColor = "bg-info-subtle border-info"; break;
	case "indice": bgColor = "bg-success-subtle border-success"; break;
	default : bgColor = "bg-secondary-subtle border-secondary-subtle"; break;
    }

    const popover = props.itemId === null ? (<></>) : (
	<Popover className="popover-lg shadow">
	    <Popover.Header className={bgColor}>
		<span className="text-uppercase fs-5">{itemContent.title}</span>
	    </Popover.Header>
	    <Popover.Body>
		<span className="fs-5">{itemContent.description}</span>
	    </Popover.Body>
	</Popover>
    );
    

    return (
	<OverlayTrigger placement={props.placement === undefined ? "top" : props.placement} overlay={popover}>
	    <Card className={"user-select-none " + bgColor}>
		<Card.Header className={"bg-transparent d-flex justify-content-start align-items-center gap-2"}>
		    <span className={"text-uppercase " + (props.itemId === null ? "text-secondary" : "")}>{itemContent.title}</span>
		    {props.state === "applied" && (<BsFillCheckCircleFill className="fs-5 text-success"/>)}
		    {props.state === "missed" && (<BsFillXCircleFill className="fs-5 text-danger"/>)}
		</Card.Header>
		{/* <Card.Body>{itemContent.description}</Card.Body> */}
	    </Card>
	</OverlayTrigger>
    );
}
